// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_two_layer_relief/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_two_layer_relief: ModuleSchema = {
  "id": "core_two_layer_relief",
  "uniqueId": "B3D_2LR01",
  "createdAt": "2026-10-14T19:00:00Z",
  "updatedAt": "2026-10-14T12:00:55.750Z",
  "label": "Two Layer Relief",
  "description": "Reusable two-group base and raised-detail relief kit (CG_2LR01).",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_2LR01",
    "two-layer",
    "relief"
  ],
  "sliders": [
    {
      "key": "detailWidth",
      "label": "Detail Width (mm)",
      "min": 4,
      "max": 100,
      "default": 24,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "detailHeight",
      "label": "Detail Height (mm)",
      "min": 4,
      "max": 100,
      "default": 18,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "cornerRadius",
      "label": "Detail Corner Radius (mm)",
      "min": 0,
      "max": 30,
      "default": 3,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "backingOffset",
      "label": "Backing Offset (mm)",
      "min": 0,
      "max": 10,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "baseDepth",
      "label": "Base Depth (mm)",
      "min": 0.1,
      "max": 30,
      "default": 8,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "raisedDepth",
      "label": "Raised Detail Depth (mm)",
      "min": 0.1,
      "max": 10,
      "default": 1,
      "step": 0.1,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "base",
      "label": "Base",
      "default": "#DB2777",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "detail",
      "label": "Raised Detail",
      "default": "#F3E8FF",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [],
  "exportGroups": []
};
